import componentFn from '../../styles/objects/component'
import { important } from '../../styles/tools/parsers'
import breakTo from '../../styles/tools/breakTo'

export default ({
  colors,
  spacings,
  images,
  fontFamilies,
  fontWeights,
  fontSizes,
  textTransforms
}) => {
  const component = componentFn({
    colors,
    spacings,
    images,
    fontFamilies,
    fontWeights,
    fontSizes,
    textTransforms
  })

  const styles = {
    checkbox: {},
    checkboxContainer: {
      [breakTo('small')]: {
        width: '100%',
        marginRight: '0'
      }
    },
    input: {
      position: 'absolute',
      left: '-9999px',

      ':enabled + label': {
        fontSize: '0.875rem',

        position: 'relative',
        display: 'inline-block',

        paddingLeft: spacings.x5,

        cursor: 'pointer',

        color: colors.common.text,
        // checkbox appearance
        '::before': {
          position: 'absolute',
          top: '0',
          left: '0',

          width: '20px',
          height: '20px',

          content: "''",

          border: `2px solid ${colors.flag.default}`,
          borderRadius: '2px',
          background: colors.flag.bg
        },
        // checked mark appearance
        '::after': {
          fontSize: spacings.x4,
          lineHeight: '20px',

          position: 'absolute',
          top: '-5px',
          left: '6px',

          width: '9px',
          height: '12px',

          content: images.checkboxTick,
          transition: 'all .2s',
          textAlign: 'center',

          border: 0,
          borderRadius: '2px'
        }
      },

      ':disabled + label': {
        color: colors.flag.default
      },

      ':not(:checked) + label::after': {
        fontSize: 0,

        opacity: 0
      },

      ':not(:checked):disabled + label::before': {
        boxShadow: 'none'
      },

      ':checked + label::before': {
        border: `2px solid ${colors.flag.checked}`,
        background: colors.flag.checked
      },

      ':checked + label::after': {
        transform: 'scale(1)',

        opacity: '1'
      },

      ':disabled + label::before': {
        boxShadow: 'none'
      },

      ':disabled + label::after': {
        border: `1px solid ${colors.flag.disabled}`
      }
    },

    // 'input--invalid': {

    //   ':enabled + label:before': {
    //     borderColor: important(colors.common.utility.error.default),
    //   }
    // },

    label: {
      fontFamily: fontFamilies.alternate
    },

    'label--invalid': {
      color: important(colors.common.utility.error.default)
    },
    'component--pull-left': {
      float: 'left'
    },
    'component--pull-right': {
      float: 'right'
    },
    'component--block': {
      display: 'block'
    }
  }

  return { ...component, ...styles }
}



// WEBPACK FOOTER //
// ./components/checkbox/styles.js